import { jsx } from 'react/jsx-runtime';
import '../../../../authentication/context/AuthenticationProvider.js';
import '@geit/ui-components';
import 'react';
import { useAppConfig } from '../../../../authentication/hooks/useAppConfig.js';
import 'qs';
import 'uuid';
import '../../../../authentication/navigate.js';
import EmpowerFooter from './components/EmpowerFooter/index.js';
import MyEmpowerFooter from './components/MyEmpowerFooter/index.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
const Footer = props => {
  const {
    app
  } = useAppConfig();
  return app === "empower" ? /* @__PURE__ */jsx(EmpowerFooter, __spreadValues({}, props)) : /* @__PURE__ */jsx(MyEmpowerFooter, {});
};
export { Footer as default };